// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"b1b2ecd1","191":"81e46f62","197":"60386bc5","198":"0685ce60","331":"553938ca","453":"3ed71c61","538":"e55782d9","615":"d402d0f8","703":"ecd680fc","748":"4db5e30e","754":"7f5ec07b","818":"758bddda"}[chunkId] + ".chunk.js";
};